import { colors, spacing } from './common';
import { MainThemeColors } from './types';

const cdkPrimaryColors: MainThemeColors = {
  primary: {
    100: '#196FE1',
    80: 'rgba(25,111,225, 0.8)',
    60: 'rgba(25,111,225, 0.6)',
    40: 'rgba(25,111,225, 0.4)',
    20: 'rgba(25,111,225, 0.2)',
    10: 'rgba(25,111,225, 0.1)',
    5: 'rgba(25,111,225, 0.05)',
    hover: {
      borderColor: '#196FE1',
      backgroundColor: '#1353A9',
    },
    focus: {
      borderColor: '#196FE1',
      backgroundColor: '#1353A9',
    },
  },
  secondary: {
    100: '#E8F1FC',
    80: 'rgba(232,241,252, 0.8)',
    60: 'rgba(232,241,252, 0.6)',
    40: 'rgba(232,241,252, 0.4)',
    20: 'rgba(232,241,252, 0.2)',
    10: 'rgba(232,241,252, 0.1)',
    5: 'rgba(232,241,252, 0.05)',
    non_alpha: '#E8F1FC',
    text: {
      color: '#155EBF',
    },
    hover: {
      backgroundColor: '#DCE9FA',
    },
  },
};

export const cdk = {
  colors: {
    ...cdkPrimaryColors,
    ...colors,
    black: {
      100: '#151B25',
      80: 'rgba(21,27,37, 0.8)',
      60: 'rgba(21,27,37, 0.6)',
      40: 'rgba(21,27,37, 0.4)',
      20: 'rgba(21,27,37, 0.2)',
      10: 'rgba(21,27,37, 0.1)',
      5: 'rgba(21,27,37, 0.05)',
    },
    success: {
      100: '#09AD00',
      80: 'rgba(9,173,0, 0.8)',
      60: 'rgba(9,173,0, 0.6)',
      40: 'rgba(9,173,0, 0.4)',
      20: 'rgba(9,173,0, 0.2)',
      10: 'rgba(9,173,0, 0.1)',
      5: 'rgba(9,173,0, 0.05)',
    },
    danger: {
      100: '#EB0000',
      80: 'rgba(235,0,0, 0.8)',
      60: 'rgba(235,0,0, 0.6)',
      40: 'rgba(235,0,0, 0.4)',
      20: 'rgba(235,0,0, 0.2)',
      10: 'rgba(235,0,0, 0.1)',
      5: 'rgba(235,0,0, 0.05)',
      non_alpha: '#FEF6F5',
    },
    info: {
      100: '#074FAF',
      80: 'rgba(7,79,175, 0.8)',
      60: 'rgba(7,79,175, 0.6)',
      40: 'rgba(7,79,175, 0.4)',
      20: 'rgba(7,79,175, 0.2)',
      10: 'rgba(7,79,175, 0.1)',
      5: 'rgba(7,79,175, 0.05)',
    },
  },
  spacing,
};
